import {
    EXECUTE_SPECIAL_WALLET_TRANSACTION,
    EXECUTE_SPECIAL_WALLET_TRANSACTION_ERROR,
    EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS,
    EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS_REDIRECTING,
    FETCH_SPECIAL_WALLETS,
    FETCH_SPECIAL_WALLETS_ERROR,
    FETCH_SPECIAL_WALLETS_SUCCESS,
    SpecialWalletsActions,
  } from '../../types/actions/SpecialWallets.actions';
  import {ISpecialWallet} from '../../types/models/SpecialWallet';
  
  export interface SpecialWalletsState {
    data: ISpecialWallet[] | null;
    isLoading: boolean;
    isPerforming: boolean;
    transactionSuccessful: boolean;
  }
  
  const initialState: SpecialWalletsState = {
    data: null,
    isLoading: false,
    isPerforming: false,
    transactionSuccessful: false,
  };
  
  export default (
    state = initialState,
    action: SpecialWalletsActions,
  ): SpecialWalletsState => {
    switch (action.type) {
      case FETCH_SPECIAL_WALLETS: {
        return {
          ...state,
          isLoading: true,
        };
      }
      case FETCH_SPECIAL_WALLETS_SUCCESS: {
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      }
  
      case FETCH_SPECIAL_WALLETS_ERROR: {
        return {
          ...state,
          isLoading: false,
          data: null,
        };
      }
      case EXECUTE_SPECIAL_WALLET_TRANSACTION: {
        return {
          ...state,
          isPerforming: true,
        };
      }
      case EXECUTE_SPECIAL_WALLET_TRANSACTION_ERROR: {
        return {
          ...state,
          isPerforming: false,
          transactionSuccessful: false,
        };
      }
      case EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS: {
        return {
          ...state,
          transactionSuccessful: action.payload,
          isPerforming: false,
        };
      }
      case EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS_REDIRECTING: {
        return {
          ...state,
          isPerforming: action.payload,
        };
      }
      default:
        return state;
    }
  };
  